import axios from 'axios'

// axios.defaults.baseURL = 'http://admx.topiputih.id/api/';
// axios.defaults.baseURL = 'http://budiy.site/api/';
// axios.defaults.baseURL = 'https://topi.seserahand.com/api/';
axios.defaults.baseURL = 'https://admin.topiputih.id/api/';
// axios.defaults.baseURL = 'http://192.168.1.9/api/';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');